import $ from "jquery";

$(window).on('load', function () {
    // Check if the necessary APIs are available
    if (typeof Vimeo === 'undefined' || typeof window.dataLayer === 'undefined') {
        console.warn('API de Vimeo o dataLayer no disponibles.');
        return;
    }

    // Find all iframes marked for tracking
    const trackedVideos = $('iframe[data-vimeo-track="true"]');
    if (trackedVideos.length === 0) {
        return;
    }

    trackedVideos.each(function () {
        const videoIframe = this;
        try {
            const player = new Vimeo.Player(videoIframe);
            const $videoIframe = $(videoIframe);

            // Get tracking data from data-* attributes
            const videoName = $videoIframe.data('video-name');
            const pageName = $videoIframe.data('page-name');
            const eventAction = `${videoName}_${pageName}`;
            const fullUrl = window.location.href;

            if (!videoName || !pageName) {
                console.warn('Faltan atributos data-video-name o data-page-name en el iframe:', videoIframe);
                return; // Skip if essential data is missing
            }

            // State variables for each individual video
            let hasStarted = false;
            const trackedQuartiles = { 25: false, 50: false, 75: false, 100: false };
            const trackedIntervals = new Set();

            // --- Event Listeners ---

            // 1. Handle video_plays (Start)
            player.on('play', () => {
                if (!hasStarted) {
                    hasStarted = true;
                    const data = {
                        event: 'video_plays',
                        event_action: eventAction,
                        event_label: 'Start',
                        full_url: fullUrl
                    };
                    window.dataLayer.push(data);
                }
            });

            // Handle video_plays (Pause)
            player.on('pause', () => {
                const data = {
                    event: 'video_plays',
                    event_action: eventAction,
                    event_label: 'Pause',
                    full_url: fullUrl
                };
                window.dataLayer.push(data);
            });

            // 2. Handle video_plays (End) and video_percent (100%)
            player.on('ended', () => {
                // Push 'End' event
                const endData = {
                    event: 'video_plays',
                    event_action: eventAction,
                    event_label: 'End',
                    full_url: fullUrl
                };
                window.dataLayer.push(endData);

                // Push '100%' event if not already tracked
                if (!trackedQuartiles[100]) {
                    trackedQuartiles[100] = true;
                    const percent100Data = {
                        event: 'video_percent',
                        event_action: eventAction,
                        event_label: '100%',
                        full_url: fullUrl
                    };
                    window.dataLayer.push(percent100Data);
                }
            });

            // 3. Handle intervals and percentages during playback
            player.on('timeupdate', (data) => {
                const percent = data.percent * 100;
                const seconds = data.seconds;

                // Handle video_percent (Quartiles)
                [25, 50, 75].forEach(q => {
                    if (percent >= q && !trackedQuartiles[q]) {
                        trackedQuartiles[q] = true;
                        const percentData = {
                            event: 'video_percent',
                            event_action: eventAction,
                            event_label: `${q}%`,
                            full_url: fullUrl
                        };
                        window.dataLayer.push(percentData);
                    }
                });

                // Handle video_interval_seconds (10s intervals)
                const currentInterval = Math.floor(seconds / 10) * 10;
                if (currentInterval > 0 && !trackedIntervals.has(currentInterval)) {
                    trackedIntervals.add(currentInterval);
                    const intervalData = {
                        event: 'video_interval_seconds',
                        event_action: eventAction,
                        event_label: `${currentInterval}s`,
                        full_url: fullUrl
                    };
                    window.dataLayer.push(intervalData);
                }
            });

        } catch (error) {
            console.error('Error al inicializar el reproductor de Vimeo:', error, videoIframe);
        }
    });
});
